import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeadlessInput from '../../headless/input/HeadlessInput';
import { MemberInfoValueMobile } from '../../headless/input/InputBody';
import HeadlessBtn from '../../headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../headless/button/BtnBody';
import { useModalStore } from '../../../store/portal/modalStore';
import { getModalMessage } from '../../../constants/modalMessages';
import { getBtnName } from '../../../constants/btnNames';
import { INPUT_TAG_NAME_MAX_LENGTH } from '../../../constants/limits';
import { getAlertMessage } from '../../../constants/alertMessages';
import { useValidation } from '../../../hooks/useValidation';
import UniversalIconBtn from '../../headless/button/UniversalIconBtn';
import belowIcon from '../../../../asset/icon/below.png';
import { CreateTagAction } from '../TagManagementTypes';

interface ModalProps extends CreateTagAction {
  setIsUserInput: (isUserInput: boolean) => void;
}

const CreateTagStationModalMobile: React.FC<ModalProps> = ({
  createTag,
  setIsUserInput,
}) => {
  const { standardModal, clearModal } = useModalStore();
  const [temp, setTemp] = useState(standardModal?.value || '');
  const [error, setError] = useState('');
  const { validateTagNameInput } = useValidation();

  const validateTagInput = (value: string) => {
    if (value.length === 0) {
      setError('');
      return true;
    }
    const msg = validateTagNameInput(value);
    if (msg) {
      setError(msg);
      return false;
    }
    setError('');
    return true;
  };

  useEffect(() => {
    if (temp.length > 0) {
      setIsUserInput(true);
    } else {
      setIsUserInput(false);
    }
  }, [temp, setIsUserInput]);

  if (standardModal == null) return null;

  const handleApply = async () => {
    if (temp.length === 0) {
      setError(getAlertMessage('MISSING_REQUIRED_FIELD'));
      return;
    }
    const msg = validateTagNameInput(temp);
    if (msg) {
      setError(msg);
      return;
    }
    await createTag({ name: temp, index: 0 });
  };

  const handleClose = () => {
    clearModal(400);
  };

  const handleTagInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value;
    if (next.length <= INPUT_TAG_NAME_MAX_LENGTH) {
      setTemp(next);
      validateTagInput(next);
    }
  };

  return (
    <ChangeModalComp>
      <TitleWrapper>
        <Title>{getModalMessage('CREATE_TAG_STATION_TITLE')}</Title>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={handleClose}
        />
      </TitleWrapper>
      <HeadlessInput
        type="text"
        value={temp}
        handleChange={handleTagInputChange}
        placeholder={getModalMessage('ENTER_FIELD', { field: standardModal?.title ?? '' })}
        StyledInput={MemberInfoValueMobile}
      />
      <ErrorText>{ error !== '' ? error : ''}</ErrorText>
      <HeadlessBtn value={getBtnName('APPLY')} handleClick={() => void handleApply()} StyledBtn={SubmitButton} />
    </ChangeModalComp>
  );
};

const ChangeModalComp = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const Title = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;



const ErrorText = styled.p`
  width: 100%;
  color: ${({ theme }) => theme.colors.color_alert_red};
  ${({ theme }) => theme.typography.Body_04};
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

export default CreateTagStationModalMobile;
